import { useWindowDimensions } from 'react-native';

import { SCROLLBAR_WIDTH } from '@/feature/responsive-design/WebComponents';
import { MAX_WEB_WIDTH } from '@/utils/constants-platform-specific';

export const SEARCH_BAR_HEIGHT = 48;
export const SEARCH_BAR_PADDING = 16;
export const SEARCH_ICON_WIDTH = 24;
export const SEARCH_TEXT_WIDTH = 54; // it's the width of the text "Search"
export const CANCEL_BUTTON_WIDTH = 78;

/**
 * The purpose of this hook is to offer one source of truth for all search bar sizes.
 * The search bar has two states: collapsed it takes the full available width,
 * expanded it shrinks to leave room for the cancel button on the right.
 */
export const useSearchDimensions = () => {
    const { width } = useWindowDimensions();
    const maxAvailableWidth = MAX_WEB_WIDTH > width ? width - SCROLLBAR_WIDTH : MAX_WEB_WIDTH;
    const fullSearchBarWidth = maxAvailableWidth - SEARCH_BAR_PADDING * 2;
    const searchMaxWidthOnSearchScreen = maxAvailableWidth - SEARCH_BAR_PADDING - CANCEL_BUTTON_WIDTH;

    return { maxAvailableWidth, fullSearchBarWidth, searchMaxWidthOnSearchScreen };
};
